import { render, staticRenderFns } from "./cardCantent.vue?vue&type=template&id=529a56cf&scoped=true&"
import script from "./cardCantent.vue?vue&type=script&lang=js&"
export * from "./cardCantent.vue?vue&type=script&lang=js&"
import style0 from "./cardCantent.vue?vue&type=style&index=0&id=529a56cf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a56cf",
  null
  
)

export default component.exports